import React, { useState, useRef } from 'react';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { db } from '../../api/firebaseConfig';
import { collection, addDoc } from "firebase/firestore";
const TestimonialModal = () => {
  // State to hold input values
  const [name, setName] = useState('');
  const [riadOwner, setRiadOwner] = useState('');
  const [testimonial, setTestimonial] = useState('');
  const [showToast, setShowToast] = useState(false);  // State for toast visibility
  
  // Modal reference
   

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Log the input values
    
    try {
        const timestamp = new Date().toISOString();
        await addDoc(collection(db, 'testimonials'), {
            seen:false,
            published:false,
            name,
            riadOwner,
            testimonial,
            createdAt: timestamp,  // Add timestamp
          });
    // Show the success toast
    setShowToast(true);

    // Reset form inputs after submission
    setName('');
    setRiadOwner('');
    setTestimonial('');

} catch (error) {
    console.error("Error adding testimonial: ", error);
  }
    
  };

  return (
    <>
    <div
      className="modal fade custom-modal"
      id="testimonialModal"
      tabIndex="-1"
      aria-labelledby="testimonialModalLabel"
      aria-hidden="true"
      style={{ zIndex: 999999 }}
     
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="testimonialModalLabel">
              Ajouter un Témoignage
            </h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Nom</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Votre nom"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Propriétaire de Riad</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nom de votre Riad"
                  value={riadOwner}
                  onChange={(e) => setRiadOwner(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Témoignage</label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Votre témoignage"
                  value={testimonial}
                  onChange={(e) => setTestimonial(e.target.value)}
                ></textarea>
              </div>
              <button type="submit" className="theme-btn">
                Envoyer
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>

    {/* Toast notification */}
    {showToast && (
      <div
        className="toast-container  position-fixed bottom-0 end-0 p-3"
        style={{ zIndex: 999999 }}
      >
        <div
          className="toast show"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          data-bs-delay="2000"
        >
          <div className="toast-header">
            <strong className="me-auto">Succès</strong>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="toast"
              aria-label="Close"
            ></button>
          </div>
          <div className="toast-body">
            Témoignage envoyé avec succès !
          </div>
        </div>
      </div>
    )}
    </>
  );
};

export default TestimonialModal;
